import React, { memo, useEffect, useRef } from "react";
// import { Spin } from "antd";
import Header from "./headerElem";
import Text from "./textElem";
import Image from "./imageElem";
import Line from "./lineElem";
import Input from "./inputElem";
import Button from "./buttonElem";
import SelectMenu from "./selectMenuElem";
import DatePicker from "./datePickerElem";
import SelectPerson from "./selectPersonElem";
import CheckBox from "./checkBoxElem";
import Plugin from "./pluginElem";
import Note from "./noteElem";
import DoubleText from "./doubleTextElem";
import TextSwitch from "./textSwitchElem";
import UlText from "./ulTextElem";
import Textarea from "./textareaElem";
import CapCard from "./capCardElem";
import Rate from "./rateElem";

// import { eventBus } from "renderer/_public/business-tools/event-bus";
import "./style/index.less";

import { getText } from "./utils";
import { ToolFnContext } from "./utils/context";

const typeDistribution = {
  header: Header,
  text: Text,
  image: Image,
  line: Line,
  input: Input,
  button: Button,
  select_menu: SelectMenu,
  date_picker: DatePicker,
  select_person: SelectPerson,
  checkbox: CheckBox,
  note: Note,
  double_text: DoubleText,
  text_switch: TextSwitch,
  cap_card: CapCard,
  ul_text: UlText,
  rate: Rate,
  text_area: Textarea,
  plugin: Plugin,
};

export default memo(
  ({
    isStreaming,
    msgData = [],
    btnRequestHandle,
    sharedContext = {},
  }: {
    isStreaming: boolean;
    msgData: any[];
    btnRequestHandle: any;
    sharedContext: any;
  }) => {
    // useEffect(() => {
    //   console.log("bgm-=sharedContext==========");
    // }, []);
    const submitTipCheck = useRef<IMultiElementCombineMsg.ISubmitTipCheck>({});
    const retrieveValues = useRef<IMultiElementCombineMsg.IRetrieveValuesObj>(
      {}
    );

    // useEffect(() => {
    //   eventBus.addListener("isMarkedStreaming", (status: boolean) =>
    //     setIsMarkedStreaming(status)
    //   );
    //   return () => {
    //     eventBus.removeListener("isMarkedStreaming");
    //   };
    // }, []);

    const setRetrieveValues = (
      item: IMultiElementCombineMsg.IRetrieveValues
    ) => {
      retrieveValues.current[item.id] = item;
    };

    // date_picker relation time
    const getRelationTime = (relationId: string) => {
      return retrieveValues.current[relationId]?.value || "";
    };

    const setSubmitState = (tipCheck: IMultiElementCombineMsg.ITipCheck) => {
      submitTipCheck.current[tipCheck.id] = tipCheck.isTip;
    };

    const wrapRequest = (params) => {
      const { elem, retrieve_values, extra_elements } = params;
      const elems = elem ? [elem] : [];
      const retrieveElems = retrieve_values
        ? Object.values(retrieveValues.current).filter((item) =>
            retrieve_values.includes(item.id)
          )
        : elems;
      const elements = [...retrieveElems, ...(extra_elements || [])];

      delete params.elem;
      delete params.retrieve_values;
      delete params.extra_elements;
      btnRequestHandle({
        ...params,
        elements,
        submitTipCheck: submitTipCheck.current,
      });
    };
    return (
      <>
        {msgData.map((item, index) => {
          if (!item || !item.type) return null;

          const Component = typeDistribution[item.type];
          return Component ? (
            <ToolFnContext.Provider value={sharedContext}>
              <Component
                key={`${item.id || item.type}-${index}`}
                data={item}
                getText={getText}
                setRetrieveValues={setRetrieveValues}
                btnRequestHandle={wrapRequest}
                getRelationTime={getRelationTime}
                setSubmitState={setSubmitState}
                isStreaming={isStreaming}
              />
            </ToolFnContext.Provider>
          ) : null;
        })}
      </>
    );
  }
);
